import { createContext, useContext } from 'react';

export const GuideContext = createContext(true);
export const useGuideEnabled = () => useContext(GuideContext);
